import { render, staticRenderFns } from "./AddCpvModal.vue?vue&type=template&id=afb863f0&scoped=true&"
import script from "./AddCpvModal.vue?vue&type=script&lang=js&"
export * from "./AddCpvModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCpvModal.vue?vue&type=style&index=0&id=afb863f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb863f0",
  null
  
)

export default component.exports